
  import { defineComponent } from "vue";
  import { isNumber } from "lodash";

  export default defineComponent({
    name: "VueProgressBar",

    props: {
      title: {
        type: String,
        required: true,
      },

      source: {
        type: String,
        required: true,
      },
    },

    computed: {
      progressClass(): string {
        if (isNumber(Number(this.source))) {
          return `progress-${Math.round(Number.parseFloat(this.source))}`;
        }

        return "progress-0";
      },
    },
  });
